module.exports = __webpack_public_path__ + "img/rate_18ct.ab38d738.jpg";